import { render, staticRenderFns } from "./PlayerCreditsSent.vue?vue&type=template&id=042d2ed6&scoped=true&"
import script from "./PlayerCreditsSent.vue?vue&type=script&lang=js&"
export * from "./PlayerCreditsSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042d2ed6",
  null
  
)

export default component.exports